import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Constants } from "src/Constants";
import { EditSpecialityModal } from "src/components/Modal/EditModal";
import { DeleteSpecialities, FetchAllSpecialities } from "src/Thunk/adminThunks";
import { clearMsg } from "src/Actions/Admin/adminActions";
const MySwal = withReactContent(Swal);

const SpecialitiesList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [editSpecialityData,setEditSpecialityData] = useState({});
  const [visible, setVisible] = useState(false)
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  let itemsPerPage = 10;

  const [deleteSuccess, setDeleteSuccess] = useState(true);
  const { specialities, msg, error } = useSelector((state) => state.admin);
  useEffect(() => {
    if (deleteSuccess) {
      dispatch(FetchAllSpecialities());
    }
  }, [deleteSuccess]);

  const filteredSpecialities = specialities[0]?.specialities?.filter(
    (customer) =>
      Object.values(customer).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchTerm.toLowerCase())
      )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSpecialities?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleDeleteSpeciality = async (name) => {
    const userData = {
      _id: specialities[0]._id,
      name: name,
    };
    dispatch(DeleteSpecialities(userData));
  };

  const handleEditSpeciality = (data) => {
    setEditSpecialityData(data)
    setVisible(true)
  }

  useEffect(() => {
    if (msg) {
      MySwal.fire({
        icon: "success",
        title: msg,
      });
      setVisible(false)
      setTimeout(() => {
        dispatch(clearMsg());
      }, 1200);
      setDeleteSuccess(false);
      setTimeout(() => {
        setDeleteSuccess(true);
      }, 1000);
    }
    if (error) {
      MySwal.fire({
        icon: "error",
        title: error,
      });
    }
  }, [msg, error]);

  return (
    <>
    <EditSpecialityModal data={editSpecialityData} visible={visible} onClose={() => setVisible(false)} />
    <div className="main-content">
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 text-info">SPECIALITIES LIST</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item text-info active">
                      Specialities List
                    </li>
                  </ol>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="card custom-shadow rounded-lg border my-3">
                <div className="card-body">
                  <Row>
                    <Col md={4} xs={12} className="mb-3 text-center">
                      <h3 className="fw-bolder text-info mb-0">
                        {specialities[0]?.specialities?.length || 0}
                      </h3>
                      <p className="text-secondary">Total Specialities</p>
                    </Col>
                  </Row>

                  <div className="dataTables_length mb-2">
                    <label>
                      <Link
                        className="btn btn-sm btn-primary text-white"
                        to={`/AddNewSpecialities`}
                      >
                        <FontAwesomeIcon icon={faPlus} /> Add New
                      </Link>
                    </label>
                    <div className="search-box">
                      <input
                        type="text"
                        id="search"
                        placeholder="Search "
                        name="search"
                        className="form-control "
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table responsive bordered22 hover>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Online Consultation Fare</th>
                          <th>Clinic Visit Fare</th>
                          <th>Speciality Icon</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems?.map((speciality, index) => (
                          <tr key={index}>
                            <td>{speciality?.name}</td>
                            <td>{`$${speciality?.clinic_fare}`}</td>
                            <td>{`$${speciality?.online_fare}`}</td>
                            <td>
                              <img
                                src={`${Constants.getAsset}${speciality.specialityIcon}`}
                                width={30}
                                height={30}
                              />
                            </td>
                            <td>
                              <div className="icon-container">
                                <Button
                                  variant="danger"
                                  size="sm"
                                  title="Delete Speciality"
                                  onClick={() => {
                                    MySwal.fire({
                                      title: "Are you sure?",
                                      text: "Once deleted, you will not be able to recover this data!",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonText: "Yes, delete it!",
                                      cancelButtonText: "No, cancel!",
                                      reverseButtons: true,
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        handleDeleteSpeciality(speciality?.name);
                                      }
                                    });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                                <Button
                                  variant="primary"
                                  size="sm"
                                  title="Edit Speciality"
                                  onClick={() => handleEditSpeciality(speciality)}
                                >
                                  <FontAwesomeIcon icon={faPenToSquare} />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <Container>
                    <div className="col-sm-12 col-md-5">
                      <div className="dataTables_length">
                        Showing {indexOfFirstItem + 1} to{" "}
                        {Math.min(
                          indexOfLastItem,
                          specialities[0]?.specialities?.length || 0
                        )}{" "}
                        of {specialities[0]?.specialities?.length || 0} entries
                      </div>
                    </div>
                    <div>
                      {Array.from({
                        length: Math.ceil(
                          specialities[0]?.specialities?.length / itemsPerPage
                        ),
                      }).map((_, index) => (
                        <button
                          key={index}
                          type="button"
                          className="btn btn-primary btn-circle btn-sm text-white m-1"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      ))}
                    </div>
                  </Container>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    </>
  );
};

export default SpecialitiesList;
